import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const getAllSubServices = () => {
  return Api(END_POINTS.getAllSubServices, null, REQUEST_TYPE.GET);
};

const getRoleWiseSubscription = (rolee) => {
  return Api(
    `${END_POINTS.getSubscriptionByRole}?role=${rolee}`,
    null,
    REQUEST_TYPE.GET
  );
};

export { getAllSubServices, getRoleWiseSubscription };
